import { Button, Typography } from "@mui/material"
import { useContext } from "react";
import { State, StateContext } from "../state";
import { TourCard } from "./tour/tour_card";
import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { T } from "../i18n";
import { useNavigate } from "react-router";

const PreferiteImg = require('./images/preferiti.png')


export const Preferites = () => {

    const { preferiteList } = useContext(StateContext) as State;

    const navigate = useNavigate()

    return (
        <div>
            <div className="container">
                <div className="pad-20">
                    <Typography variant="h4">{T('preferite_jumbo_title')}</Typography>
                    <br/>
                    <div className="row-wrap gap-20 card-fullwidth row-center">
                        {preferiteList.map((t: any) => (
                            <TourCard tour={t} /> 
                        ))}
                        {preferiteList.length === 0 && 
                            <div style={{textAlign: "center"}}>
                                <img src={PreferiteImg} width={"100%"}/>
                                <Typography sx={{ typography: { md: 'h4', xs: 'h5' } }}>{T('preferite_title')}</Typography>
                                <Typography sx={{ typography: { md: 'h5', xs: 'body' } }}> 
                                    {T('preferite_d1')}
                                    <FavoriteBorder style={{verticalAlign: "middle", margin: "0 5px"}}/>
                                    {T('preferite_d2')}
                                    <Favorite style={{fill: '#E91E63', verticalAlign: "middle", margin: "0 5px"}} />
                                </Typography>
                                <br/><br/>
                                <Button variant="contained" className="round-btn huge-btn" color="info" size="large" onClick={() => navigate('/list')}>{T('preferite_btn')}</Button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}